import React from 'react';

import InviteDate from './Date';

function Dates(props) {
  const confirmed = (props.status == 1);

  // Display the confirmed date only if the invite has been confirmed
  var filteredDates = props.dates.filter((date) => {
    return confirmed ? date.confirmed : true;
  });

  var dates = filteredDates.map((date) => {
    return (
      <InviteDate key={date.id} date={date} voters={props.participants} />
    )
  })

  if (dates.length) {
    return (dates);
  } else {
    return (
      <p className="no-date">
        <i className="material-icons md-36 md-dark md-inactive u-pull-left">date_range</i>
        No date yet
      </p>
    );
  }
}

export default Dates;
